import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  // responsive layout
  logincontainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "100vh",
    padding: 0,
    margin: 0,
    overflowX: "hidden",
  },

leftpanel: {
  flex: "0 0 70%",
  height: "100vh",
  backgroundImage: `url("/Sml-banner-final.png")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top left",
  backgroundSize: "133% auto",
  overflow: "hidden",

  [theme.breakpoints.down("md")]: {
    flex: "0 0 30%",
    backgroundColor: "transparent",
    backgroundImage: `url("/Sml-banner-final.png")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top left",
    backgroundSize: "100% auto",
  },
},

rightpanel: {
  flex: "0 0 30%",
  height: "100vh",
  width:"100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#e8e9e9",
  [theme.breakpoints.down("md")]: {
    flex: "0 0 30%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f3f1f3ff",
  },
},

  loginWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  loginCard: {
    width: "100%",
    maxWidth: 360,
    padding: "24px 20px",
    margin: "30px auto",
    boxShadow: "0 0 0 rgba(0,0,0,0.1)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  logo: {
    width: "200.8px",
    height: "138px",
    borderRadius: "10px",
    display: "block",
    margin: "0 auto",
    marginBottom: "8px",
    objectFit: "cover",
  },

  container: {
    height: "100vh",
    overflow: "hidden",
  },
  innerContainer: {
    justifyContent: "center",
    alignItems: "center",
  },

  Form: {
    background: "#ffffff 0% 0% no-repeat padding-box",
    border: "1px solid #777777",
    opacity: "1",
    textAlign: "left",
    letterSpacing: "0px",
    color: "#F3F3F3",
    opacity: "0.7",
    width: "100%",
    maxWidth: 475,
    height: "480px",
  },

  LoginButton: {
    color: "#57B793",
    borderRadius: "28px",
    height: "56px",
    opacity: "1",
    background: "#57B793 0% 0% no-repeat padding-box",
    textAlign: "center",
    font: "normal normal bold 18px/24px Nunito Sans",
    letterSpacing: " 0px",
    "&:hover, &:focus": {
      color: "#ffffff",
      backgroundColor: "#57B793",
    },
  },
  logotypeContainer: {
    backgroundColor: "#0B0B0B",
    width: "60%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  logotypeImage: {
    width: "100%",
    marginBottom: theme.spacing(4),
  },
  logotypeText: {
    color: "white",
    fontWeight: 500,
    fontSize: 84,
    [theme.breakpoints.down("md")]: {
      fontSize: 48,
    },
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
  },
  form: {
    width: 320,
  },
  tab: {
    fontWeight: 400,
    fontSize: 18,
  },
  greeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(4),
  },
  subGreeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  googleButton: {
    marginTop: theme.spacing(6),
    boxShadow: theme.customShadows.widget,
    backgroundColor: "white",
    width: "100%",
    textTransform: "none",
  },
  googleButtonCreating: {
    marginTop: 0,
  },
  googleIcon: {
    width: 30,
    marginRight: theme.spacing(2),
  },
  creatingButtonContainer: {
    marginTop: theme.spacing(2.5),
    height: 46,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  createAccountButton: {
    height: 46,
    textTransform: "none",
  },
  formDividerContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    alignItems: "center",
  },
  formDividerWord: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  formDivider: {
    flexGrow: 1,
    height: 1,
    backgroundColor: theme.palette.text.hint + "40",
  },
  errorMessage: {
    textAlign: "center",
  },
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: theme.palette.primary.light,
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "&:hover:before": {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderBottomColor: theme.palette.background.light,
  },
  formButtons: {
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#57B793",
    "&:hover, &:focus": {
      color: "#57B793",
      backgroundColor: "#57B793",
    },
  },
  loginButton: {
    backgroundColor: "#5D90B4",
    width: "100%",
    color: "#fff",
  },
  forgetButton: {
    textTransform: "none",
    fontWeight: 400,
  },
  loginLoader: {
    marginLeft: theme.spacing(4),
  },
  copyright: {
    marginTop: theme.spacing(4),
    whiteSpace: "nowrap",
    color: "#57B793",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: theme.spacing(2),
    },
  },
  root: {
    "&$focused $notchedOutline": {
      borderColor: "#5CB593 !important",
    },
  },
  notchedOutline: {},
  focused: {},
}));
